import React from 'react';
import { FormattedMessage } from 'translations';
import classnames from 'classnames';
import InteractiveInfoBlock from 'app/components/base/InteractiveInfoBlock';

import style from './style.css';


// Constants
const messages = {
  title: { id: 'BOOK_TRIP.ALREADY_HAVE_ACCOUNT' },
  text: { id: 'BOOK_TRIP.SIGN_IN_FASTER_CHECKOUT' },
  button: { id: 'SIGN_IN' }
};

const SignInBox = (props) => {
  const {
    onClickSignIn,
    mobile
  } = props;

  const modifiers = {
    [style['container--mobile']]: mobile
  };

  const text = (
    <div className={classnames(style.container, modifiers)}>
      <div className={style.title}>
        <FormattedMessage {...messages.title} />
      </div>
      <div className={style.text}>
        <FormattedMessage {...messages.text} />
      </div>
    </div>
  );

  const button = [{
    title: <FormattedMessage {...messages.button} />,
    onClick: onClickSignIn
  }];

  return (
    <InteractiveInfoBlock
      className={classnames(style.wrapper, { [style.interactiveBlock]: mobile })}
      type="white"
      text={text}
      buttons={button}
      buttonsOnNextLine={mobile}
      contentAlign="center start"
    />
  );
};

// TODO: move to Flow types
// SignInBox.propTypes = {
//   onClickSignIn: PropTypes.func,
//   mobile: PropTypes.bool
// };

export default SignInBox;
